const tc = {
  greeting: '歡迎您',
  label_btn_details: '詳細內容',
  pagination: {
    First: '«',
    Prev: '上一頁',
    Next: '下一頁',
    Last: '»',
  },
  pagenotfound: {
    title: '找不到網頁',
    desc: '很抱歉，您尋找的網頁暫時未能顯示。',
  },
  header_bar: {
    link_home: {
      name: '香港貿發局網站',
      url: 'https://www.hktdc.com/tc/',
    },
    link_about: {
      name: '關於香港貿發局',
      url: 'http://aboutus.hktdc.com/tc',
    },
    link_media: {
      name: '新聞中心',
      url: 'http://mediaroom.hktdc.com/tc',
    },
    title_login: '登入',
    title_logout: '登出',
    title_edit_profile: '編輯用戶資料',
    title_register: '註冊',
    title_myhktdc: '我的HKTDC',
    txt_back: '返回',
    link_myhktdc: 'https://home.hktdc.com/tc/myhktdc',
  },
  speaker: {
    popup: {
      remark: '* For high-resolution photos, please click the images.',
    },
  },
  under_construction: {
    text: '將於稍後公布',
  },
  loading: '載入中',
  search: {
    placeholder: '參展商/ 供應商/ 產品/ 展位編號/ 品牌',
    validation: '請輸入關鍵字!',
  },
  sbeProgramme: {
    venue: '地點',
    language: '語言',
    remarks: '備註',
    hkTimezone: 'HKT',
  },
  photo: {
    view: '預覽',
    download: '下載',
  },
  video: {
    date: '日期',
    duration: '影片長度',
    close: '關閉',
  },
};

export default tc;
